import { useMutation, useQueryClient } from 'react-query';
import { API } from 'aws-amplify';
import { updateSkill } from '../../graphql/mutations';
import QUERY_CACHE_KEY from '../../constants/QueryCacheKey';

function useUpdateSkillMutation(id, options = {}) {
  const client = useQueryClient();

  return useMutation(
    (input) => {
      return API.graphql({
        query: updateSkill,
        variables: {
          input: {
            id,
            ...input,
          },
        },
      });
    },
    {
      ...options,
      onSuccess: (res) => {
        client.invalidateQueries(QUERY_CACHE_KEY.skills());
        if ('function' === typeof options.onSuccess) {
          options.onSuccess(res);
        }
      },
    }
  );
}

export default useUpdateSkillMutation;
